import Accordion from '../components/Accordion'
import ProductCartForm from '../components/ProductCartForm'
import ProductGallery from '../components/ProductGallery'
import ProductSlider from '../components/ProductSlider'
import ProductSuggestion from '../components/ProductSuggestion'

export default class Product {
    constructor() {
        new Accordion()
        new ProductSlider()
        new ProductGallery()
        new ProductCartForm()
        new ProductSuggestion()
    }
}
